import { render, staticRenderFns } from "./menu-bar.vue?vue&type=template&id=4ab6ce5b&scoped=true"
import script from "./menu-bar.vue?vue&type=script&lang=ts"
export * from "./menu-bar.vue?vue&type=script&lang=ts"
import style0 from "./menu-bar.vue?vue&type=style&index=0&id=4ab6ce5b&prod&lang=css"
import style1 from "./menu-bar.vue?vue&type=style&index=1&id=4ab6ce5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab6ce5b",
  null
  
)

export default component.exports